module.exports = __webpack_public_path__ + "img/skipPoint.0787266d.png";